import omit from 'lodash/omit';
import { createReducer } from 'typesafe-actions';
import { type Actions, uploadAsset, uploadAssetProgress } from './actions.js';
import type { NAME } from './constants.js';

export type AssetUploadState = {
  progress: number;
  error?: string;
};

export type AssetUploaderState = Record<string, AssetUploadState>;

export type AssetUploaderSlice = {
  [NAME]: AssetUploaderState;
};

const initialState: AssetUploaderState = {};

export default createReducer<AssetUploaderState, Actions>(initialState)
  .handleAction(uploadAsset.pending, (state, { meta }) => {
    return {
      ...state,
      [meta.filename]: { ...state[meta.filename], progress: 0 }
    };
  })
  .handleAction(uploadAssetProgress, (state, { payload }) => {
    return {
      ...state,
      [payload.filename]: {
        ...state[payload.filename],
        progress: payload.progress
      }
    };
  })
  .handleAction(uploadAsset.fulfilled, (state, { meta }) => {
    return omit(state, meta.filename);
  })
  .handleAction(uploadAsset.rejected, (state, { meta }) => {
    return omit(state, meta.filename);
  });
